import { createContext, useContext } from 'react'

const DisabledInputContext = createContext(false)

export const DisabledInputProvider = DisabledInputContext.Provider

/** True when inputs should render their current value disabled, bypassing show-changes diffing. */
export const useIsDisabledInput = () => useContext(DisabledInputContext)
